const BASE_URL = import.meta.env.VITE_API_BASE || "";

export const APIURLS = {
  baseUrl: BASE_URL + "/api/admin/",
};
// API_KEY removed
export const API_KEY = import.meta.env.VITE_API_KEY;

export const APICONSTANT = {
  login: "user/login",
  loginOut: "user/logout",
  getPublicKey: "auth/public-key",
  generateCaptcha: "captcha/generate-captcha",
  branchLogin: "member/branch-login",
  financial_data: "member-application",
  admin_financial_data: "admin/application/",
  user_list: "admin/member/branch-list",
  // reg_form_list: "member-application/lease-list",
  user_reg_form_list: "member-application/list",
  admin_reg_form_list: "admin/application/list",
  user_add: "admin/user/add",
  file_upload: "upload/upload-single/",
  multiple_upload: "upload/upload-multiple/",

  //menu
  menu_list: "report",
  //
  //master
  region_list: "master/regions",
  district_list: "master/districts",
  division_list: "master/divisions",
  taluk_list: "master/taluks",
  village_list: "master/villages",
  isd_list: "master/isd",
  service_list: "master/service",
  mode_list: "master/mode",
  //application status
  application_status: "report/chart/",
  //ruralDetails Count
  chart_details: "report/chart/",
  chart_list: "report/",
  analysis: "report/chart/",
  aiRemarkSubmit: "report/chart-review/",
  chartReviewList: "report/chart-review",
};

// {{BASE_URL}}api/admin/report/chart/1?tabId=1
